import React from 'react';
import { connect } from 'react-redux';

import MainContent from '../components/layout/MainContent';
import Title from '../components/typography/Title';
import SeaticsPolicyWidget from '../components/features/SeaticsPolicyWidget';

import { createFetchingView } from '../helpers/views';

class PoliciesView extends React.PureComponent {
  componentDidMount() {
    this.props.setFetching(true);
  }

  handleSeaticsPolicyWidgetReady = () => {
    setTimeout(() => {
      this.props.setFetching(false);
    }, 400);
  };

  renderContent() {
    return (
      <MainContent
        id="PoliciesView"
        className="sk-fade-in-quarter-second"
      >
        <Title align="center">Policies</Title>
        <SeaticsPolicyWidget
          onReady={this.handleSeaticsPolicyWidgetReady}
        />
      </MainContent>
    );
  }

  render() {
    if (this.props.isReady) {
      return this.renderContent();
    }

    return null;
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: false,
  ...ownProps,
});

export default connect(mapStateToProps)(createFetchingView(PoliciesView));



// WEBPACK FOOTER //
// ./src/views/PoliciesView.js